import { PayloadAction } from "@reduxjs/toolkit";
import { CategoryGameType, GameStateType } from "types/game";

import { initialState } from ".";

export const reducers = {
  setCategoryGame: (
    state: GameStateType,
    action: PayloadAction<CategoryGameType>
  ) => {
    state.categoryGame = { ...action.payload };
  },
  setPrevProvider: (state: GameStateType, action: PayloadAction<string>) => {
    state.prevProvider = action.payload;
  },
  resetDataSubGame: (state: GameStateType) => {
    state.dataSubGame = initialState.dataSubGame;
    state.msgError = initialState.msgError;
  },
  resetGame: () => initialState,
};
